import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock4 } from "lucide-react";
import { CONTACT } from "@/lib/siteData";

export const ContactDirect = () => {
  return (
    <section id="contact" className="py-28 lg:py-36 bg-[#1A1714] text-[#FAF7F2]" data-testid="contact-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-16"
        >
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#BFA574] mb-5">
            Échange sans intermédiaire
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight leading-[1.15]">
            Parlons de votre chantier,{" "}
            <span className="italic text-[#BFA574]">directement.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-[#FAF7F2]/70">
            Contactez Louis Larsson par téléphone ou courriel.
            Réponse garantie sous 24 à 48 heures, visite technique gratuite.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-5">
          <motion.a
            href={CONTACT.phoneHref}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="group border border-[#FAF7F2]/15 rounded-sm p-10 hover:border-[#BFA574] hover:bg-[#FAF7F2]/5 transition-colors duration-500"
            data-testid="contact-phone-link"
          >
            <Phone className="w-7 h-7 text-[#BFA574] mb-8" strokeWidth={1.5} />
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[#FAF7F2]/50 mb-3">Téléphone</p>
            <p className="font-serif-display text-3xl sm:text-4xl font-light group-hover:text-[#BFA574] transition-colors duration-500">
              {CONTACT.phoneDisplay}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-[#FAF7F2]/60">
              <Clock4 className="w-4 h-4" /> {CONTACT.hours}
            </p>
          </motion.a>

          <motion.a
            href={CONTACT.emailHref}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.12 }}
            className="group border border-[#FAF7F2]/15 rounded-sm p-10 hover:border-[#BFA574] hover:bg-[#FAF7F2]/5 transition-colors duration-500"
            data-testid="contact-email-link"
          >
            <Mail className="w-7 h-7 text-[#BFA574] mb-8" strokeWidth={1.5} />
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[#FAF7F2]/50 mb-3">Courriel</p>
            <p className="font-serif-display text-2xl sm:text-3xl font-light break-all group-hover:text-[#BFA574] transition-colors duration-500">
              {CONTACT.email}
            </p>
            <p className="mt-4 text-sm text-[#FAF7F2]/60">
              Envoyez vos photos et dimensions pour un pré-chiffrage
            </p>
          </motion.a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-10 border border-[#FAF7F2]/10 rounded-sm px-8 py-6"
          data-testid="contact-zone-info"
        >
          <p className="flex items-center gap-3 text-sm text-[#FAF7F2]/75">
            <MapPin className="w-4 h-4 text-[#BFA574] shrink-0" />
            Zone d'intervention : {CONTACT.zone}
          </p>
          <p className="flex items-center gap-2.5 font-mono-tech text-[11px] uppercase tracking-wider text-[#7FB285]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7FB285] opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#7FB285]" />
            </span>
            Chantiers acceptés pour le trimestre en cours
          </p>
        </motion.div>
      </div>
    </section>
  );
};
